import { ItemReference } from '../../api/api-items';

export function ItemReferencesSidebar(props: { isLoading: boolean; referencedBy: ItemReference[] }) {
  const { isLoading, referencedBy } = props;

  return (
    <div className='border-r border-neutral-200 flex flex-col overflow-hidden min-w-100'>
      <div className='px-4 py-5 border-b border-neutral-200 bg-neutral-50'>
        <h3 className='text-base font-semibold text-neutral-900'>References</h3>
        <p className='text-sm text-neutral-700'>The following items references this item.</p>
      </div>
      <div className='flex-1 overflow-auto'>
        {isLoading ? (
          <div className='text-sm text-neutral-500'>Loading references...</div>
        ) : referencedBy.length > 0 ? (
          <div className=''>
            {referencedBy.length > 0 && (
              <div>
                <div className='px-4 py-2 border-b border-neutral-200 bg-neutral-100'>
                  <h4 className='font-medium text-sm text-neutral-950'>
                    Referenced By ({referencedBy.length} or more)
                  </h4>
                </div>
                <div className='divide-y'>
                  {referencedBy.map((ref) => (
                    <div key={ref.referenceId} className='text-sm px-4 py-1.5'>
                      <div className='flex items-start justify-between gap-2'>
                        <div className='flex-1'>
                          <div className='font-medium text-neutral-950'>
                            {ref.sourcePrimaryKey} (field: {ref.sourceField})
                          </div>
                          <div className='text-neutral-600'>{ref.sourceEntityId}</div>
                        </div>
                        {/* <ExternalLinkIcon className='size-4 text-neutral-400 flex-shrink-0' /> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className='text-sm text-neutral-500'>No references found</div>
        )}
      </div>
    </div>
  );
}
